// @ts-nocheck
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { withRouter } from '../../../../router-compat';
import { CSVLink } from 'react-csv';
import { observer, inject } from "../../../../stores/mobx-compat";
import moment from 'moment';

import Card from '../../../ui/Card';
import Table, {
  Th, Td, Tr, TableToolbar, TablePager,
} from '../../../ui/Table';
import Button from '../../../ui/Button';
import Empty from '../../../ui/Empty';
import { DownloadIcon, ClipboardIcon } from '../../../ui/icons';
import { TABLE_ITEMS_PER_PAGE } from '../../../../enums';

class SummaryOverview extends Component {
  state = {
    activePage: 1,
    sortState: { column: 'Forms Started', direction: 'descending' },
  }

  headerMap = {
    page_view: 'Page Views',
    sessions: 'Unique Visitors',
    forms_started: 'Forms Started',
    unique_valid_abandoned_emails: 'Abandons w/ Email',
    emails_delivered: 'Emails Delivered',
    unique_email_opens: 'Unique Email Opens',
    recaptures: 'Recaptures',
    submits: 'Submits',
  }

  get sortState() { return this.state.sortState; }

  get headerRow() {
    return ['Form Url', ...this.statKeys.map((k) => this.headerMap[k] || k)];
  }

  get statKeys() {
    const stKeys = ['forms_started', 'unique_valid_abandoned_emails', 'submits'];
    const { auth } = this.props.store;
    if (auth.user.analytics) stKeys.push('page_view', 'sessions');
    if (typeof auth.paidPlan === 'function' ? auth.paidPlan() : auth.paidPlan) {
      stKeys.push('emails_delivered', 'unique_email_opens', 'recaptures');
    }
    return stKeys;
  }

  get summaryData() {
    const { column, direction } = this.state.sortState;
    const { filters, createSummaryRows } = this.props.store.analytics;

    const cached = localStorage.getItem('summaryData');
    const cachedDate = localStorage.getItem('summaryDataCachedDate');
    const cachedTimeSpan = Number(localStorage.getItem('summaryDataTimeSpan'));
    const cachedDomain = localStorage.getItem('summaryDataDomainFilter') === 'null'
      ? null : localStorage.getItem('summaryDataDomainFilter');
    const cachedPath = localStorage.getItem('summaryDataPathFilter') === 'null'
      ? null : localStorage.getItem('summaryDataPathFilter');
    const today = moment().format('l');

    const sortRows = (rows) => rows.slice().sort((a, b) => {
      const colIndex = this.headerRow.indexOf(column);
      let comp = 0;
      if (!Number.isNaN(Number(a[colIndex]))) {
        comp = Number(a[colIndex]) - Number(b[colIndex]);
      } else if (a[colIndex] > b[colIndex]) comp = 1;
      else if (a[colIndex] < b[colIndex]) comp = -1;
      return direction === 'ascending' ? comp : -comp;
    });

    let rows;
    if (!cached || JSON.parse(cached).length === 0 || cachedDate !== today
      || cachedTimeSpan !== filters.timeSpanInMonths
      || cachedDomain !== filters.domain || cachedPath !== filters.path) {
      localStorage.setItem('summaryDataCachedDate', today);
      localStorage.setItem('summaryDataTimeSpan', filters.timeSpanInMonths);
      localStorage.setItem('summaryDataDomainFilter', filters.domain);
      localStorage.setItem('summaryDataPathFilter', filters.path);
      rows = sortRows(createSummaryRows(this.statKeys));
    } else {
      rows = sortRows(JSON.parse(cached));
    }
    localStorage.setItem('summaryData', JSON.stringify(rows));
    return rows;
  }

  handleSort = (clickedColumn) => {
    this.setState((s) => {
      if (s.sortState.column !== clickedColumn) {
        return { sortState: { column: clickedColumn, direction: 'descending' } };
      }
      return {
        sortState: {
          column: s.sortState.column,
          direction: s.sortState.direction === 'ascending' ? 'descending' : 'ascending',
        },
      };
    });
  }

  render() {
    const rows = this.summaryData;
    const totalPages = Math.ceil(rows.length / TABLE_ITEMS_PER_PAGE) || 1;
    // Clamp: a filter change can shrink the row set below the current page,
    // which would otherwise leave the table stuck on an empty page.
    const activePage = Math.min(this.state.activePage, totalPages);
    const start = (activePage - 1) * TABLE_ITEMS_PER_PAGE;
    const slice = rows.slice(start, start + TABLE_ITEMS_PER_PAGE);

    return (
      <Card padded={false}>
        <TableToolbar
          title="By form URL"
          count={rows.length}
          right={(
            <CSVLink
              filename="summarized_recapture_data.csv"
              data={[this.headerRow, ...rows]}
              style={{ textDecoration: 'none' }}
            >
              <Button variant="primary" icon={DownloadIcon} disabled={rows.length === 0}>
                Download CSV
              </Button>
            </CSVLink>
          )}
        />

        {rows.length === 0 ? (
          <div className="p-5">
            <Empty
              icon={ClipboardIcon}
              title="No data yet"
              sub="Add a form to start collecting analytics."
              actions={(
                <Button variant="primary" onClick={() => this.props.history.push('/forms')}>
                  Manage forms
                </Button>
              )}
            />
          </div>
        ) : (
          <>
            <Table>
              <thead>
                <tr>
                  {this.headerRow.map((h, i) => (
                    <Th
                      key={h}
                      sortable
                      active={this.sortState.column === h}
                      direction={this.sortState.direction === 'ascending' ? 'asc' : 'desc'}
                      onSort={() => this.handleSort(h)}
                      align={i === 0 ? 'left' : 'right'}
                    >
                      {h}
                    </Th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {slice.map((row, ri) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <Tr key={ri}>
                    {row.map((col, ci) => (
                      <Td
                        // eslint-disable-next-line react/no-array-index-key
                        key={ci}
                        align={ci === 0 ? 'left' : 'right'}
                        mono={ci !== 0}
                      >
                        {ci === 0
                          ? <a href={`https://${col}`} target="_blank" rel="noopener noreferrer" className="text-mov-accent-ink underline-offset-2 hover:underline">{`https://${col}`}</a>
                          : Number(col).toLocaleString()}
                      </Td>
                    ))}
                  </Tr>
                ))}
              </tbody>
            </Table>
            <TablePager
              page={activePage}
              totalPages={totalPages}
              total={rows.length}
              onChange={(p) => this.setState({ activePage: p })}
            />
          </>
        )}
      </Card>
    );
  }
}

export default withRouter(inject('store')(observer(SummaryOverview)));
